<template v-if="isShowProductImage">
  <div class="p-image" :style="[imageStyles]">
    <a target="_blank" :href="product.link">
      <img :src="product.image" />
    </a>
  </div>
</template>

<script>
export default {
  name: "ProductImage",
  props: ["product"],
  computed: {
    isShowProductImage: function() {
      return this.$store.state.front.settings.imageDisplay;
    },
    imageStyles: function() {
      return {
        width: this.$store.state.front.settings.imageWidth
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.p-image {
  width: 80px;
  margin: 0 10px 0 0;
  img {
    width: 100%;
    height: auto;
    margin: auto;
    padding: 0;
  }
}
</style>